import { formatWeight } from "../utils";
import { CompanyData } from "../DummyWeightInputTab/types";
import PtfDeltaCellContainer from "./PtfDeltaCell.styles";

interface PtfDeltaCellProps {
    rowOrValue: CompanyData | number;
}

const DELTA_THRESHOLD = 0.0045;

const getDeltaClass = (value: number): string => {
    if (value >= DELTA_THRESHOLD) return "positive";
    if (value <= -DELTA_THRESHOLD) return "negative";
    return "";
};

const PtfDeltaCell = ({ rowOrValue }: PtfDeltaCellProps) => {
    if (typeof rowOrValue === "number") {
        return <>{formatWeight(rowOrValue)}</>;
    }

    const delta = (rowOrValue as any).ptf_delta;
    const deltaClass = getDeltaClass(delta);

    return (
        <PtfDeltaCellContainer className={deltaClass}>
            {formatWeight(delta)}
        </PtfDeltaCellContainer>
    );
};

export default PtfDeltaCell;
